import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RappService } from 'src/app/services/rapp-services.service';
import { ContactInfo, DnvLatLng, ImageFile, PhoneType, ProblemMenuSelection, PhoneTypeValue, QuestionAnswer, QuestionTypes} from 'src/app/store/application';
import { isMobile } from 'src/assets/isMobileChecker';

import * as $ from 'jquery';

declare var L: any;

@Component({
  selector: 'app-submission-review',
  templateUrl: './submission-review.component.html',
  styleUrls: ['./submission-review.component.scss']
})
export class SubmissionReviewComponent implements OnInit {
  @Input() selectedProblemMenuItem: ProblemMenuSelection | null;
  @Input() problemDetails: string;
  @Input() problemPhotos: ImageFile[];
  @Input() selectedLatLng: DnvLatLng | null;
  @Input() contactInfo: ContactInfo;
  @Input() problemLocation: string;
  @Input() problemQuestions: QuestionAnswer[];
  @Output() proceedToStep = new EventEmitter<number>();

  mapElementRenderedTimer: any;
  locationText = "";
  map: any;
  contactInfoLocal: ContactInfo;

  isMobile = isMobile;
  marker: any;

  constructor(private rappService: RappService) { }

  ngOnInit(): void {
    this.mapElementRenderedTimer = setInterval(() => {
      if (document.getElementById("map")) {
        this.buildDnvMap();
        this.zoomIfSelectedLatLng();

        clearInterval(this.mapElementRenderedTimer);
      }
    }, 100);

    this.contactInfoLocal = Object.assign({}, this.contactInfo);
  }

  goToStep(step: number) {
    this.proceedToStep.emit(step);
  }

  handleKeypress(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      (event.target as any).click();
    }
  }

  handleMouseDown(event: MouseEvent) {
    event.preventDefault();
  }

  buildDnvMap() {
    const northWestBound = { lat: 49.67, lng: -123.55 };
    const southEastBound = { lat: 48.96, lng: -122.6 };
    const bounds = L.latLngBounds(northWestBound, southEastBound);
    const centerPoint = { lat: 49.33801, lng: -123.04363 };
    const crs = new L.Proj.CRS('EPSG:26910', '+proj=utm +zone=10 +ellps=GRS80 +datum=NAD83 +units=m +no_defs', {
      origin: [474584, 5480125],
      resolutions: [
        21.16670900008467, 10.583354500042335, 5.291677250021167, 2.6458386250105836, 1.3229193125052918,
        0.6614596562526459, 0.26458386250105836, 0.13229193125052918, 0.06614596562526459
      ]
    });

    this.map = L.map('map', {
      crs: crs,
      zoomControl: false,
      keyboard: false,
      minZoom: 0,
      maxZoom: 6,
      maxBounds: bounds,
      tap: true,
      scrollWheelZoom: false
    }).setView(centerPoint, 5);

    L.esri.tiledMapLayer({
      url: 'https://geoweb.dnv.org/arcgis/rest/services/Basemap_Building/MapServer',
      minZoom: 0,
      maxZoom: 6,
      opacity: 1
    }).addTo(this.map);

    document.getElementById("map")?.addEventListener("mousedown", () => this.map.dragging.disable());
  }

  createLeafletMarker(latLng: DnvLatLng) {
    let svgMarker = L.divIcon({
      html: `
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
        <desc>Created with Fabric.js 1.7.22</desc>
        <defs></defs>
        <g transform="translate(128 128) scale(0.72 0.72)">
          <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)" >
            <path d="M 45 0 C 32.957 0 23.159 9.798 23.159 21.841 c 0 11.369 8.732 20.732 19.841 21.746 V 88 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 V 43.587 c 11.109 -1.014 19.841 -10.377 19.841 -21.746 C 66.841 9.798 57.043 0 45 0 z M 50.863 20.5 c -3.032 0 -5.5 -2.467 -5.5 -5.5 c 0 -3.033 2.467 -5.5 5.5 -5.5 c 3.032 0 5.5 2.467 5.5 5.5 C 56.364 18.033 53.896 20.5 50.863 20.5 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
          </g>
        </g>
      </svg>
      `,
      className: "markerIcon"
    });

    // this.marker = L.marker(latLng, { icon: svgMarker }).addTo(this.map);
    this.marker = L.marker(latLng).addTo(this.map);
  }

  zoomIfSelectedLatLng() {
    if (!!this.selectedLatLng && this.selectedLatLng?.lat !== 0 && this.selectedLatLng.lng !== 0) {
      this.map.setView(this.selectedLatLng, 5);
      // L.marker(this.selectedLatLng).addTo(this.map);
      this.createLeafletMarker(this.selectedLatLng);
    }
  }

  getPhoneFormatting(phoneNumber: string = ""): string {
    const areaCode = phoneNumber.substring(0, 3);
    const middle = phoneNumber.substring(3, 6);
    const last = phoneNumber.substring(6, 10);

    return `(${areaCode}) ${middle}-${last}`;
  }

  checkDefinedPhones() {
    let phonesDefined = false;
    let phonesDefinedArr: PhoneType[] = [];
    this.contactInfoLocal.phone.forEach(phone => {
      if (!!phone && phone.phoneNumber.length === 10) {
        phonesDefined = true;
        let phoneType = phone.phoneType;

        if (!phoneType) {
          phoneType = PhoneTypeValue.Other;
        }

        phonesDefinedArr.push({
          phoneType,
          phoneNumber: phone.phoneNumber
        });
      }
    });

    this.contactInfoLocal.phone = phonesDefinedArr;
    return phonesDefined;
  }

  convertToPhoneType(typeNumValue: string) {
    switch (typeNumValue) {
      case PhoneTypeValue.Home:
        return 'Home';

      case PhoneTypeValue.Cell:
        return 'Cell';

      case PhoneTypeValue.Work:
        return 'Work';

      default:
        return 'Other';
    }
  }

  generateNewProblemDesc() {
    let problemDesc = this.problemDetails;
    let builtDescStr = "";

    this.problemQuestions.forEach(question => {
      if (question.answer && question.questionType !== QuestionTypes.ConfirmationToggle) {
        builtDescStr += `${question.question}: ${question.answer}`;

        if (question.radioOtherOptionEntry) {
          builtDescStr += ` - ${question.radioOtherOptionEntry}`;
        }

        builtDescStr += '<br>';

      } else if (question.questionType === QuestionTypes.Checkbox && question.checkOptionAnswers?.some(optionAnswer => optionAnswer.answer)) {
        builtDescStr += `${question.question}: `
        let checkedItemsStr = '';

        if (question.questionType === QuestionTypes.Checkbox) {
          question.checkOptionAnswers.forEach(optionAnswer => {
            if (optionAnswer.answer) {
              checkedItemsStr += `${optionAnswer.option}, `;
            }
          });

          // remove trailing comma and whitespaces
          checkedItemsStr.replace(/,\s*$/, "");
        }

        builtDescStr += checkedItemsStr + '<br>';
      } else if (question.questionType === QuestionTypes.ConfirmationToggle) {
        builtDescStr += `${question.question}: ${question.confirmationStatus}`;
      }
    });

    if (builtDescStr.length > 0) {
      builtDescStr += '<br>';
    }

    builtDescStr += problemDesc;
    return builtDescStr;
  }

  getNotificationStatus() {
    return this.contactInfo.notificationsRequested ? 'Enabled' : 'Disabled';
  }

  contactEntryPopulated(): boolean {
    let populated = (this.contactInfoLocal.address?.length || this.contactInfoLocal.email.length || this.contactInfoLocal.firstName.length ||
      this.contactInfoLocal.lastName.length || this.checkDefinedPhones()) as boolean;

    return populated;
  }
}
